module.exports = __webpack_public_path__ + "img/invoice-de-female-wm-sl.e36ed731.png";